"use client";

import "swiper/css";

export { Swiper, SwiperSlide } from "swiper/react";
export type { Swiper as SwiperClass } from "swiper/types";
